import {httpsCallable} from 'firebase/functions';
import {functions} from './firebase';

const AddeparManager = {
  getEntity: async entity_id => {
    try {
      const getEntity = httpsCallable(functions, 'addepar-getEntity');
      const entity = await getEntity({entity_id});

      return entity;
    } catch (err) {
      console.error('ADDEPAR MANAGER', err);
      throw err;
    }
  },

  // getOAuthUrl: async () => {
  //   try {
  //     const getOAuthUrl = httpsCallable(functions, 'addepar-getOauthUrl');

  //     const url = await getOAuthUrl({
  //       redirectUri: 'http://localhost:3000/addeparConnect',
  //     });

  //     return url;
  //   } catch (err) {
  //     console.error('ADDEPAR MANAGER', err);
  //     throw err;
  //   }
  // },

  exchangeCodeForToken: async (code, redirectUri) => {
    try {
      const exchangeCode = httpsCallable(
        functions,
        'addepar-exchangeAddeparAuthCode',
      );
      const result = await exchangeCode({code, redirectUri});

      return result.data;
    } catch (err) {
      console.error('ADDEPAR TOKEN EXCHANGE ERROR:', err);
      throw err;
    }
  },

  refreshToken: async refreshToken => {
    try {
      const refreshTokenFunction = httpsCallable(
        functions,
        'addepar-refreshAddeparToken',
      );
      const result = await refreshTokenFunction({refreshToken});

      return result.data;
    } catch (err) {
      console.error('ADDEPAR TOKEN REFRESH ERROR:', err);
      throw err;
    }
  },
};

export default AddeparManager;
